import { initials } from 'module/helpers/initials';
import { isString } from 'lodash';
import { css } from 'styled-components';

// TODO: Use CSS variables here to keep CSS in sync

export const Text01 = css`
  color: var(--gray-100);
`;

export const Inverse = css`
  color: var(--white-100);
`;

export const Text02 = css`
  color: var(--gray-70);
`;

export const Text03 = css`
  color: var(--gray-40);
`;

export const Link01 = css`
  color: var(--blue-60);
`;

export const VisitedLink = css`
  color: var(--purple-60);
`;

export const TextError = css`
  color: var(--red-60);
`;
export type Color =
  | 'blue'
  | 'gray'
  | 'cyan'
  | 'cool-gray'
  | 'green'
  | 'magenta'
  | 'purple'
  | 'red'
  | 'teal'
  | 'yellow'
  | 'orange'
  | 'white';

export const ALL_COLORS: Color[] = [
  'blue',
  'gray',
  'cyan',
  'cool-gray',
  'green',
  'magenta',
  'purple',
  'red',
  'teal',
  'yellow',
];

export const ALL_COLORS_WITHOUT_GRAY: Color[] = [
  'blue',
  'cyan',
  'green',
  'magenta',
  'purple',
  'red',
  'teal',
  'yellow',
];

/* NOTE:: Do not add  yellow or teal to available colors */
export const AVAILABLE_SPACE_COLORS: Color[] = [
  'blue',
  'cyan',
  'green',
  'magenta',
  'purple',
  'red',
];

export const GanttBarColors: Color[] = [
  'blue',
  'green',
  'magenta',
  'cyan',
  'purple',
  'teal',
];

export enum StatusColors {
  Blocked = 'var(--red-60)',
  Cancelled = 'var(--cool-gray-40)',
  Completed = 'var(--green-40)',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Default = 'var(--cool-gray-40)',
  InPlanning = 'var(--purple-60)',
  InProgress = 'var(--green-50)',
  Proposed = 'var(--blue-40)',
  ToBeStaffed = 'var(--orange-40)',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  ToDo = 'var(--blue-40)',
}

export enum ToastIconColors {
  Success = 'var(--green-30)',
  Error = 'var(--red-50)',
  Warning = 'var(--yellow-50)',
  Info = 'var(--white-100)',
}

export enum ToastUI {
  backgroundColor = 'var(--warm-gray-90)',
  textColor = 'var(--white-100)',
  padding = 'var(--spacing-04)',
  borderRadius = 'var(--border-radius-small)',
  minWidth = '372px',
  zIndex = 'var(--zindex-layer-1111)',
}

export const SmartFillTagColors = ALL_COLORS.filter(
  (_color) => !['blue', 'gray', 'cool-gray'].includes(_color),
);

export const getRandomColor = (
  seed: number | string,
  palette?: Color[],
): Color => {
  const _palette = palette ?? ALL_COLORS;

  if (isString(seed)) {
    const initialsString = initials(seed as string);
    let colorIndex = 0;

    [...initialsString].forEach((char, index) => {
      colorIndex += initialsString.charCodeAt(index);
    });

    colorIndex -= 'A'.charCodeAt(0);

    return _palette[Math.abs(Math.ceil(colorIndex) % _palette.length)];
  }

  return _palette[Math.ceil(seed as number) % _palette.length];
};
